module.exports = {
	baseURL: '/api',
	staticDomain: 'http://erptest.hivemedia.cn/attachment'
}



// WEBPACK FOOTER //
// ./src/utils/env.js